import React, { useEffect } from 'react';
import { X } from 'lucide-react';
import PostModalContent from './PostModalContent';
import { useSinglePost } from '../../hooks/useSinglePost';

const PostModal = () => {
  // Use custom hook for all logic
  const {
    socialAccounts,
    regeneratedPost,
    isPostRegenerating,
    handleEditSubmit,
    handleScheduleSubmit,
    handleRegenerateSubmit,
    isOpen,
    closeModal,
    post,
  } = useSinglePost();

  // Effect: manage body overflow on modal open/close
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = 'unset';
    }
    return () => {
      document.body.style.overflow = 'unset';
    };
  }, [isOpen]);

  // Conditional rendering: don't render if modal not open or no post
  if (!isOpen || !post) {
    return null;
  }

  return (
    <div className='fixed inset-0 bg-white z-50 flex flex-col overflow-hidden overflow-y-auto lg:overflow-y-hidden'>
      {/* Header with Close Button */}
      <div className='flex-shrink-0 flex justify-end items-center px-4 py-0 lg:py-1 border-b bg-gray-50'>
        <button
          onClick={closeModal}
          className='text-gray-600 hover:text-gray-800 hover:bg-gray-200 rounded-full p-2 transition-colors'
          title='Close'
        >
          <X className='w-6 h-6' />
        </button>
      </div>
      <div>
        {/* Main Body - Grid Layout */}
        <PostModalContent
          post={!!regeneratedPost && !isPostRegenerating ? regeneratedPost : post}
          isLoading={isPostRegenerating}
          onRegenerateSubmit={handleRegenerateSubmit}
          socialAccounts={socialAccounts}
          onScheduleSubmit={handleScheduleSubmit}
          onEditSubmit={handleEditSubmit}
          onClose={closeModal}
          showProductImage
        />
      </div>
    </div>
  );
};

export default PostModal;
